<template>
  <section class="project-item-wrapper">
    <h1>{{ project?.name }}</h1>
    <div class="project-item__img">
      <img :src="`${project?.img}`" :title="project?.name" :alt="project?.name" />
    </div>
    <div class="project-item__desc">
      <h2>Stack:</h2>
      {{ project?.desc }}
    </div>
    <div class="project-item__links">
      <!--noindex-->
      <div v-if="project?.link" class="link-item">
        <a target="_blank" :href="project?.link">Ссылка на работу</a>
      </div>
      <div v-if="project?.github" class="link-item">
        <a target="_blank" :href="project?.github">Ссылка на работу github</a>
      </div>
      <!--/noindex-->
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  project: {
    type: Object,
    required: true,
  },
});
const project = computed( () => props.project);
</script>
